import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'iconsax-react';
import { SectionRail } from '@ui/components/common/micro-interactions/SectionRail';
import './settings-bar.scss';
export function SettingsBar() {
    const navigate = useNavigate();
    return _jsx("header", { className: "settings-bar", children: _jsxs("div", { className: "settings-bar__heading", children: [_jsx("button", { type: "button", className: "settings-bar__back", "aria-label": "Terug", onClick: () => navigate(-1), children: _jsx(ArrowLeft, { size: 20, "aria-hidden": "true" }) }), _jsx("h1", { className: "settings-bar__title", children: "Settings" })] }) });
}
/** The existing animated side rail stays the navigation on every screen size. */
export function SettingsSidebar({ value, items, onChange }) {
    const [desktop, setDesktop] = useState(() => typeof window.matchMedia !== 'function' || window.matchMedia('(min-width: 768px)').matches);
    const [mobileOpen, setMobileOpen] = useState(false);
    useEffect(() => {
        if (typeof window.matchMedia !== 'function')
            return;
        const media = window.matchMedia('(min-width: 768px)');
        const update = () => setDesktop(media.matches);
        update();
        media.addEventListener('change', update);
        return () => media.removeEventListener('change', update);
    }, []);
    // Keep the disclosure open after a choice, preserving keyboard focus and
    // cancelled draft navigation. The native summary closes it when requested.
    const activeLabel = items.find(item => item.value === value)?.label || 'Settings';
    return _jsx("aside", { className: "settings-sidebar", children: _jsxs("details", { className: "settings-sidebar__disclosure", open: desktop || mobileOpen, onToggle: event => { if (!desktop)
                setMobileOpen(event.currentTarget.open); }, children: [_jsxs("summary", { className: "settings-sidebar__summary", children: [_jsx("span", { children: "Instellingenmenu" }), _jsx("strong", { children: activeLabel })] }), _jsx("div", { className: "settings-sidebar__rail", children: _jsx(SectionRail, { ariaLabel: "Settings sections", value: value, items: items, onChange: next => { if (next !== value)
                            onChange(next); } }) })] }) });
}
